import * as I18n from 'i18n-js';
import * as React from 'react';

import SiteSearch from './site_search';

import ReverbSiteSearchSuggestions from './reverb_site_search_suggestions';

import ReverbSiteSearchController from './reverb_site_search_controller';

export interface ISiteBanner {
  saleUrl: string;
  heading: string;
}

interface IProps {
  defaultValue: string;
  siteBanner?: ISiteBanner;
}

export default class ReverbSiteSearch extends React.Component<IProps> {
  render() {
    return (
      <SiteSearch
        fetchSuggestions={ReverbSiteSearchSuggestions.fetch}
        submitQuery={ReverbSiteSearchController.submitQuery}
        selectSuggestion={ReverbSiteSearchController.selectSuggestion}
        defaultValue={this.props.defaultValue}
        siteBanner={this.props.siteBanner}
        placeholderText={I18n.t('discovery.siteSearch.placeholder')}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/components/discovery/site_search/reverb_site_search.tsx